import {useLang} from '../components/LangProvider'
import {useDialog} from '../components/DialogProvider'
import {useAuth} from '../components/AuthProvider'

function Header({menuHandler, menuOpen}){

  const {lang, updateLang} = useLang()
  const openDialog = useDialog()
  const {auth} = useAuth()


  const LoginBtn = () => {
    if (auth.isAuth){
      return<>
        <div className="button-red button-login" onClick={() => openDialog("logout")}>{auth.username}</div>
      </>
    }else{
      return<>
        <div className="button-red button-login" onClick={() => openDialog("register")}>{lang["button login"]}</div>
      </>
    }
  }

  return <header>
    <span className="hamburger-box">
      <span className="hamburger-inner"></span>
    </span>
    <button className={"menu-toggle" + (menuOpen ? " menu-opened" : "")} onClick={() => menuHandler()}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
        <path d="M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z"/>
      </svg>
    </button>
    <img className="logo" src="/assets/images/logoColor.svg" alt="newrun logo" />
    <div className="socials">
      <a href={lang["socials telegram link"]}><span className="fa telegram"></span></a>
      <a href={lang["socials instagram link"]}><span className="fa instagram"></span></a>
      <a href={lang["socials facebook link"]}><span className="fa facebook"></span></a>
    </div>
    {LoginBtn()}
    <div className="lang-switch">
      <a href="#" onClick={() => updateLang("ua")} className={lang["lang"] === "ua" ? "selected" : null}>UA</a>
      <a href="#" onClick={() => updateLang("en")} className={lang["lang"] === "en" ? "selected" : null}>EN</a>
    </div>
  </header>
}

export default Header